<template>
  <div
    ref="focusedElement"
    :id="`${name}_card-wrapper`"
    class="custom-checkbox-group-field"
    :question-id="`question_${questionNum}`"
    :class="[wrapperStyle.class, fieldValue ? 'checked-true' : '']"
    :style="[wrapperStyle.style]"
  >
    <div
      class="card hoverable"
      @select="$_imSelected()"
      :class="[cardStyle.class]"
      :style="[cardStyle.style]"
    >
      <div class="card-content">
        <div class="snippet-message" v-if="preState.active && control.disable">
          {{ preState.message }}
        </div>
        <p class="check-box-field" v-show="!control.disable">
          <label>
            <input
              :disabled="control.disable || fieldDisable || isDisabled"
              type="checkbox"
              class="filled-in"
              v-model="fieldValue"
            />
            <span></span>
          </label>
        </p>
        <p class="check-box-field" v-show="control.disable">
          <label>
            <input
              :disabled="control.disable || isDisabled"
              type="checkbox"
              class="filled-in"
            />
            <span></span>
          </label>
        </p>
        <div class="card-title" v-if="titleText">
          <div class="question-number" v-show="showQuestionNum">
            {{ questionNum }}.
          </div>
          <span class="title-text" v-html="titleText"></span>
          <a class="anchor-a" @click="showDescription = !showDescription">
            <i class="material-icons-outlined" v-if="description"
              >help_outline</i
            >
          </a>
        </div>
        <div class="title-divider"></div>
        <!--  <div class="clear"></div> -->
        <ExpandTray
          :close-button="true"
          @tipAction="showDescription = false"
          v-if="showDescription"
          :data-description="description"
          :data-note="note"
        />
        <!--    <div class="clear"></div> -->
        <div class="slot-content" v-if="slotContent" v-html="slotContent"></div>

        <!-- <div class="description" v-if="description" v-html="description"></div> -->

        <component :is="list_type" class="list" v-if="list">
          <li v-for="(item, i) in list" :key="i">
            <span v-html="item.displayText"></span>
            <a class="anchor-a" v-if="item.addtional">
              <i class="material-icons-outlined" @click="$_expand(i)"
                >help_outline</i
              >
            </a>
            <component
              :is="item.componentLoader"
              :data-value="dataAdditionalValue"
              @updateValue="$_updateAdditionalValue"
              v-if="item.componentLoader"
            ></component>

            <ExpandTray
              :close-button="true"
              @tipAction="$_expand($event)"
              v-if="selectedExpand === i"
              :data-expand="item.additional"
            />
            <div class="more_details" v-if="item.more_detail">
              <span v-html="item.more_detail"></span>
            </div>
          </li>
        </component>
        <div class="slider" v-if="dataSlides">
          <custom-slider :data-slides="dataSlides"></custom-slider>
        </div>

        <div class="note" v-if="note && !description">
          <div class="note-title">
            Note:
          </div>
          <!-- <i class="material-icons-outlined">sticky_note_2</i> -->
          <div class="note-details">
            <span v-html="note"></span>
            <component
              :is="noteComponent.componentLoader"
              :data-value="dataAdditionalValue"
              :data-text="noteComponent.text"
              :data-parent-value="fieldValue"
              @updateValue="$_updateAdditionalValue"
              v-if="noteComponent"
            ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExpandTray from "../../addons/ExpandTray.vue";
import customSlider from "@/components/customSlider";
export default {
  name: "CustomCheckboxesField",
  components: { ExpandTray, customSlider },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: () => "",
    },
    homeProfile: {
      type: [Object, Boolean],
    },
    noteComponent: {
      type: Object,
    },
    dataAdditionalValue: {
      type: [String, Boolean],
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: false,
      default: null,
    },
    slotContent: {
      type: [String, Boolean],
      default: false,
    },
    list_type: {
      type: String,
      required: false,
      default: "ul",
    },
    description: String,
    label: {
      type: String,
      required: false,
    },
    dataSlides: {
      type: [Array, Boolean],
      default: false,
    },
    note: String,
    titleText: {
      type: String,
      default: () => "",
    },
    selectorGridStyle: {
      type: [Object],
      default: () => ({}),
    },
    showQuestionNum: {
      type: Boolean,
      default: false,
    },
    questionNum: {
      type: Number,
      default: () => null,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    browserDefault: {
      type: Boolean,
      default: () => true,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cardStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
    preState: {
      type: Object,
      default: () => {
        return {
          active: false,
        };
      },
    },
  },
  data() {
    return {
      zoomInstances: {
        instances: null,
        options: {},
      },
      fieldValue: this.value,
      showSelector: false,
      selectedExpand: null,
      isFocused: false,
      showDescription: false,
      fieldDisable: false,
    };
  },
  beforeDestroy() {
    if (this.zoomInstances.instances) {
      this.zoomInstances.forEach((x) => {
        x.desroy();
      });
    }
  },
  mounted() {
    setTimeout(() => {
      let elems = document.querySelectorAll(".materialboxed");
      this.zoomInstances = M.Materialbox.init(elems, {
        // specify options here
      });
    }, 1000);

    if (this.noteComponent && this.noteComponent.disableParent) {
      this.fieldDisable = !!this.dataAdditionalValue;
    }
  },
  watch: {
    fieldValue() {
      this.$_updateValue();
    },
  },
  computed: {
    control: {
      get() {
      /*   this[this.preState.object][this.preState.option].findIndex(
                      (x) => x === this.preState.value
                    ) > -1 */
        if (this.preState.active && !this[this.preState.object]) return false
        const getConditons = (isValueArray) =>{ 
          if(this.preState.values && isValueArray) {
            let res = this.preState.values.map(x =>  this[this.preState.object][this.preState.option].indexOf(x))
           return res.some(y => y > -1)
          } else {
            return this[this.preState.object][this.preState.option].findIndex(
                      (x) => x === this.preState.value
                ) > -1
          }
        }
        const arrCheck = this.preState.active
          ? Array.isArray(this[this.preState.object][this.preState.option])
          : false;
        return this.preState.active
          ? {
              disable:
                arrCheck &&
                this[this.preState.object][this.preState.option].length === 1
                  ? getConditons(true)
                  : this[this.preState.object][this.preState.option] ===
                    this.preState.value,
              isChecked: this.preState.isChecked,
              type: arrCheck ? "isArray" : "not",
            }
          : false;
      },
    },
  },
  methods: {
    $_updateAdditionalValue(val) {
      this.$emit("updateAdditional", val);
      if (this.noteComponent && this.noteComponent.disableParent) {
        if (this.fieldValue && val) this.fieldValue = false;
        this.fieldDisable = !!val;
      }
    },
    $_updateValue() {
      this.$emit("update", this.fieldValue);
    },
    $_imSelected() {
      let toClear = document.querySelectorAll("div.focused");
      if (toClear.length > 0) {
        toClear.forEach((x) => {
          x.classList.remove("focused");
        });
      }
      setTimeout(() => {
        this.$refs.focusedElement.classList.add("focused");
      }, 150);
    },
    $_updateSelectorValue(value) {
      this.fieldValue = value;
      this.showSelector = false;
      this.$_updateValue();
    },
    $_expand(index) {
      if (this.selectedExpand === index) {
        this.selectedExpand = null;
      } else {
        this.selectedExpand = index;
        this.$emit("tipStatus", true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cst {
  font-size: 18px !important;
  margin-bottom: 12px;
}

.custom-checkbox-group-field {
  &.focused {
    .card {
      &::before {
        content: "•";
        font-size: 32px;
      }
    }
  }

  .card {
    .card-content {
      padding: 16px 16px;
      display: flow-root;
      position: relative;
      .check-box-field {
        float: left;
      }
      .card-title {
        float: left;
        width: calc(100% - 38px);
        font-size: 19px;
        line-height: 25px;
        transform: translateY(-2px);
        margin-bottom: 0px;
        margin-left: -6px;
        display: flex;
        .question-number {
          margin: 0 5px 0 0px;
          font-size: 18px;
          font-weight: 500;
        }
      }
      .clear {
        width: 100%;
        height: 1px;
        clear: both;
        display: flex;
      }
    }
  }
}
.anchor-a {
  /*   display: inline-block; */
  cursor: pointer;
  margin: 0px 0 0px 6px;
  vertical-align: middle;
  margin: 0 0 0px 3px;
  i {
    color: #5374f8;
  }
}
ol {
  &.list {
    margin: 6px 0px;
    list-style: upper-alpha;
    li {
      margin-bottom: 24px;
      &::marker {
        font-size: 18px;
      }
    }
  }
}

.note {
  margin-top: 16px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  /*   border: 1px solid #dadada; */
  position: relative;
  i {
    font-size: 44px;
    margin-right: 14px;
    color: #565656;
    transform: translateY(-50%);
    top: 50%;
    position: absolute;
  }
  .note-title {
    font-weight: 600;
  }
  .title-text {
    font-size: 18px;
    font-weight: 500;
  }
  .note-details {
    font-size: 13.5px;

    /* text-justify: inter-word; */
    /*  margin-left: 53px; */
  }
}
</style>
<style lang="scss">
.custom-checkbox-group-field {
  .list {
    .flex-rows {
      @media screen and (max-width: 690px) {
        width: calc(100% + 40px);
        margin: 16px 0px 16px -40px;
      }
    }
  }
  .flex-rows {
    display: inline-flex;
    overflow: hidden;
    width: 100%;
    overflow-x: scroll;
    padding: 12px 16px 10px 16px;
    border-radius: 9px;
    background-color: #ebebeb;
    margin: 16px 0px 16px 0px;
    .flex-columns {
      width: 160px;
      margin-right: 12px;
      min-width: 160px;
      .card {
        height: calc(100% - 1.5rem);
        .card-content {
          padding: 12px 12px 4px 12px;
          img {
            max-width: 100%;
          }
        }
        .card-custom-title {
          padding: 2px 12px 12px;
          /*        overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          letter-spacing: 0.5px; */
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }

  .list-label {
    font-weight: 400;
    font-size: 18px;
    margin-bottom: 11px;
    display: block;
  }
  .list-note {
    font-size: 14px;
    padding: 12px;
    border-radius: 5px;
  }
  .title-divider {
    width: 100%;
    height: 1px;
    background: #e5e5e5;
    position: relative;
    clear: both;
    margin: -1px 0px 0;
    display: inline-block;
  }
}
.slot-content {
  ul {
    &.browser-default {
      margin-top: 6px;
      li {
        margin-bottom: 6px;
        font-size: 15px;
      }
    }
  }
}
ol.is-roman {
  list-style-type: lower-roman;
}
</style>
